import { Group, NumberInput, Stack, Text } from '@mantine/core';
import { ControlledOptionsSwitcher } from '@/app/components/shared/navigation/OptionsSwitcher';
import { useFormContext } from '../../../contexts/formContext';
import { SettingTitle } from '../../../components/SettingTitle';

const path = 'sceneManipulation.removeSmallFeatures';

export function RemoveSmallGeometry() {
  const form = useFormContext();
  const value =
    typeof form.values.sceneManipulation?.removeSmallFeatures?.removalCount === 'number'
      ? 'removalCount'
      : 'removalPercentage';

  return (
    <Stack gap='xs'>
      <SettingTitle
        title='Remove Small Geometry'
        description='Remove small meshes below a certain threshold in % or absolute value of the bbox size'
      />
      <ControlledOptionsSwitcher
        options={
          [
            { label: 'Percentage', value: 'removalPercentage' },
            { label: 'Absolute Value', value: 'removalCount' },
          ] as const
        }
        onChanged={(value) => {
          if (value === 'removalPercentage') {
            form.setFieldValue(path, {
              removalPercentage: 0,
            });
            return;
          }

          if (value === 'removalCount') {
            form.setFieldValue(path, {
              removalCount: 0,
            });
          }
        }}
        value={value}
        renderOption={(option) => {
          if (option === 'removalCount') {
            return (
              <Group gap='xs'>
                <Text>Below BBox Size:</Text>
                <NumberInput min={0} {...form.getInputProps(`${path}.removalCount`)} />
              </Group>
            );
          }

          if (option === 'removalPercentage') {
            return (
              <Group gap='xs'>
                <Text>Below Percentage:</Text>
                <NumberInput min={0} max={100} {...form.getInputProps(`${path}.removalPercentage`)} />
              </Group>
            );
          }
        }}
      />
    </Stack>
  );
}
